import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmationDialogService } from '../services/confirmation-dialog.service';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const confirmationDialog = inject(ConfirmationDialogService);
  return confirmationDialog.openConfirmationDialog(
    'Unsaved Changes',
    'You have unsaved changes. Are you sure you want to leave this page?',
    'Leave',
    'Stay',
    'exit_to_app',
    'edit'
  );
};
